import { render, staticRenderFns } from "./Datamaps.vue?vue&type=template&id=4f53901c"
import script from "./Datamaps.vue?vue&type=script&lang=js"
export * from "./Datamaps.vue?vue&type=script&lang=js"
import style0 from "./Datamaps.vue?vue&type=style&index=0&id=4f53901c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports